import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import {
  getModifiedObjects,
  getTimeDifference,
  secondsToHHMM,
  separateInsertAndUpdate,
} from "../../../Utilitie";
import SuccessMsg from "../../../Extra/SuccessMsg";
import FailedMsg from "../../../Extra/FailedMsg";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { MdDelete } from "react-icons/md";
import { IoCheckbox } from "react-icons/io5";
import Loading from "../../../Extra/Loading";
const EXCLUDED_NEW_KEYS = [
  "indent_hdr_id",
  "destination",
  "commodity",
  "wagons",
  "wagon_type",
  "fcn_no",
  "fcn_date",
  "fcn_time",
  "checkedDeleted",
];

const tableHead = [
  //   { head: "Action", rowSpan: 2, colSpan: 1 },
  { head: "S/N", rowSpan: 2, colSpan: 1 },
  { head: "Siding", rowSpan: 2, colSpan: 1 },
  { head: "Destination", rowSpan: 2, colSpan: 1 },
  { head: "EMBD /S.SUPPLY", rowSpan: 2, colSpan: 1 },
  { head: "LAST IRE", rowSpan: 2, colSpan: 1 },
  { head: "CMDT [PTY-B/C/D]", rowSpan: 2, colSpan: 1 },
  { head: "Wgns", rowSpan: 2, colSpan: 1 },
  { head: "update Wgns", rowSpan: 2, colSpan: 1 },
  { head: "Type", rowSpan: 2, colSpan: 1 },
  { head: "FCN NO.", rowSpan: 2, colSpan: 1 },
  { head: "FCN", rowSpan: 1, colSpan: 2 },
  { head: "Arr", rowSpan: 1, colSpan: 2 },
  { head: "Placed", rowSpan: 1, colSpan: 2 },
  { head: "ExpRdy", rowSpan: 1, colSpan: 3 },
  { head: "Ready", rowSpan: 1, colSpan: 2 },
  { head: "BPC", rowSpan: 2, colSpan: 1 },
  { head: "Valid(Y/N)", rowSpan: 2, colSpan: 1 },
  { head: "Siding Dep", rowSpan: 1, colSpan: 2 },
  { head: "RL_DP", rowSpan: 2, colSpan: 1 },
  { head: "REMARKS RDY TO DEP", rowSpan: 2, colSpan: 1 },
  { head: "Action ", rowSpan: 2, colSpan: 1 },
];

const subHead = [
  "Date",
  "Time",
  "Date",
  "Time",
  "Date",
  "Time",
  "Date",
  "Time",
  "remark",
  "Date",
  "Time",
  "Date",
  "Time",
];

const sidingOrder = [
  "JQSG",
  "BCSW",
  "UCLM",
  "MYR/KJS",
  "RCPB",
  "DDSG",
  "UCLT",
  "PCIH",
];

const defaultStyle = {
  minWidth: "105px",
  height: "40px",
  padding: "0px",
  margin: "0px",
  fontSize: "14px",
  boxSizing: "border-box",
  textAlign: "center",
};

const CementLoading = ({
  data,
  selectedDate,
  options = {},
  prevLoadingData,
  setReFetch,
  setIndentCount,
}) => {
  const { userData } = useGlobalContext();
  const [show, setShow] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [result, setResult] = useState(null);
  const [rows, setRows] = useState([]);
  const [tempRows, setTempRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [insertDataRes, setInsertDataRes] = useState();
  const [updateDataRes, setUpdateDataRes] = useState();

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  useEffect(() => {
    const finalRows = [];

    // Get all sidings available in data + prevLoadingData
    const allSidings = new Set();

    // from data
    data?.forEach((item) => {
      item.dtl_data?.forEach((d) => {
        if (d.pick_drop_flag === "S" && d.pick_drop_point) {
          allSidings.add(d.pick_drop_point);
        }
      });
    });

    // from prevLoadingData
    prevLoadingData?.forEach((p) => {
      if (p.siding) allSidings.add(p.siding);
    });

    // Add remaining sidings after the ordered ones
    const orderedSidings = [
      ...sidingOrder,
      ...[...allSidings].filter((s) => !sidingOrder.includes(s)),
    ];

    orderedSidings.forEach((siding) => {
      let rowsForSiding = [];

      // CASE: data available
      if (data?.length) {
        const matches = data.filter((item) =>
          item.dtl_data?.some(
            (d) => d.pick_drop_flag === "S" && d.pick_drop_point === siding,
          ),
        );

        rowsForSiding = matches.map((item) => {
          const row = createDataRow(item, siding, finalRows.length + 1);

          const loadingMatch = prevLoadingData?.find(
            (p) => p.indent_hdr_id === item.hdr_data.id,
          );

          return loadingMatch
            ? {
                ...row,
                ...loadingMatch,
                disabled: false,
                isNew: false,
              }
            : row;
        });
      }

      // CASE: no data but prevLoadingData exists
      if (!rowsForSiding.length && prevLoadingData?.length) {
        rowsForSiding = prevLoadingData.filter((p) => p.siding === siding);
      }

      // CASE: nothing found
      if (!rowsForSiding.length) {
        finalRows.push(createEmptyRow(siding, finalRows.length + 1));
      } else {
        finalRows.push(...rowsForSiding);
      }
    });

    // Add loading rows whose indent_hdr_id doesn't exist in data
    if (data?.length && prevLoadingData?.length) {
      const extraRows = prevLoadingData.filter(
        (p) => !data.some((d) => d.hdr_data.id === p.indent_hdr_id),
      );

      extraRows.forEach((row) => {
        if (
          !finalRows.some(
            (r) =>
              r.id === row.id ||
              (r.indent_hdr_id === row.indent_hdr_id &&
                r.siding === row.siding),
          )
        ) {
          finalRows.push({
            ...row,
            disabled: false,
            isNew: false,
          });
        }
      });
    }

    const rowsWithSn = finalRows.map((row, index) => {
      let expReadyId = null;
      let expReadyDate = null;
      let expReadyTime = null;
      let expReadyRemark = "";

      const expReady = [...(row.exp_ready || [])].sort((a, b) => {
        const aDate = new Date(a.exp_ready_date);
        const bDate = new Date(b.exp_ready_date);

        return bDate - aDate; // latest exp_ready_date first
      });
      if (expReady.length > 0) {
        const latest = expReady[0];

        expReadyId = latest.id;
        expReadyDate = latest.exp_ready_date?.slice(0, 10) || "";
        expReadyTime = latest.exp_ready_time || "";
        expReadyRemark = latest.exp_ready_remark || "";
      }
      return {
        ...row,
        sn: index + 1,

        exp_ready_found: expReadyId,

        exp_ready_date: expReadyDate,
        exp_ready_time: expReadyTime,
        exp_ready_remark: expReadyRemark,
      };
    });
    setRows(rowsWithSn);
    setTempRows(rowsWithSn);
  }, [data, prevLoadingData]);

  const createEmptyRow = (siding, sn) => ({
    indent_hdr_id: null,
    isNew: true,
    disabled: true,
    siding,
    sn,
    destination: "",
    embedded_supply: "",
    last_ire: "",
    commodity: "",
    wagons: "",
    loading_wagons: "",
    wagon_type: "",
    fcn_no: "",
    fcn_date: null,
    fcn_time: null,
    arr_date: null,
    arr_time: null,
    placed_date: null,
    placed_time: null,
    exp_ready_found: null,

    exp_ready_date: null,
    exp_ready_time: null,
    exp_ready_remark: "",
    ready_date: null,
    ready_time: null,
    bpc: "",
    valid: "",
    siding_date: null,
    siding_time: null,
    rl_dp: "",
    remarks: "",
  });

  const createDataRow = (item, siding, sn) => ({
    indent_hdr_id: item.hdr_data?.id,
    isNew: false,
    disabled: false,
    siding,
    sn,
    destination:
      item.dtl_data
        ?.filter((x) => x.pick_drop_flag === "D")
        .map((x) => x.pick_drop_point)
        .join(", ") || null,
    embedded_supply: null,
    last_ire: null,
    commodity: item.hdr_data?.commodity || null,
    wagons: item.hdr_data?.wagons || null,
    loading_wagons: null,
    wagon_type: item.hdr_data?.wagon_type || null,
    fcn_no: item.hdr_data?.fcn_no || null,
    fcn_date: item.hdr_data?.order_date || null,
    fcn_time: item.hdr_data?.order_time || null,
    arr_date: null,
    arr_time: null,
    placed_date: null,
    placed_time: null,
    exp_ready_found: null,

    exp_ready_date: null,
    exp_ready_time: null,
    exp_ready_remark: "",
    ready_date: null,
    ready_time: null,
    bpc: null,
    valid: null,
    siding_date: null,
    siding_time: null,
    rl_dp: null,
    remarks: null,
  });
  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const updated = [...prev];

      const row = {
        ...updated[index],
        [field]: value,
      };

      if (field === "exp_ready_date") {
        const expReady = [...(row.exp_ready || [])].sort(
          (a, b) =>
            new Date(b.created_date || b.exp_ready_date) -
            new Date(a.created_date || a.exp_ready_date),
        );

        const sameDate = expReady.find(
          (e) => e.exp_ready_date?.slice(0, 10) === value,
        );

        if (sameDate) {
          row.exp_ready_found = sameDate.id;
          row.exp_ready_time = sameDate.exp_ready_time || "";
          row.exp_ready_remark = sameDate.exp_ready_remark || "";
        } else {
          row.exp_ready_found = null;
          row.exp_ready_time = "";
          row.exp_ready_remark = "";
        }
      }

      // Calculate rl_dp whenever Ready or Siding fields change
      if (
        row.ready_date &&
        row.ready_time &&
        row.siding_date &&
        row.siding_time
      ) {
        const diff = getTimeDifference(
          row.ready_date.slice(0, 10),
          row.ready_time,
          row.siding_date.slice(0, 10),
          row.siding_time,
        );

        row.rl_dp = secondsToHHMM(Math.floor(diff.totalMilliseconds));
      } else {
        row.rl_dp = null;
      }

      updated[index] = row;
      return updated;
    });
  };
  const handleAdd = (index) => {
    const current = rows[index];
    const newRow = createEmptyRow(current.siding, rows.length + 1);
    newRow.disabled = false;
    setRows((prev) => {
      const temp = [...prev];
      temp.splice(index + 1, 0, newRow);
      return temp;
    });
  };

  const handleDelete = async (index) => {
    const row = rows[index];
    if (row.isNew) {
      setRows((prev) => prev.filter((_, i) => i !== index));
      return;
    }
    try {
      await axios.delete(`/api/loading/${row.id}`);
      setRows((prev) => prev.filter((_, i) => i !== index));
    } catch (error) {
      console.error(error);
      alert("Failed to delete record");
    }
  };
  const renderInput = (
    row,
    index,
    field,
    type = "text",
    disabled = false,
    isSelect = false,
    options = [],
  ) => {
    let rlDpValue = null;

    if (
      field === "rl_dp" &&
      row.ready_date &&
      row.ready_time &&
      row.siding_date &&
      row.siding_time
    ) {
      const diff = getTimeDifference(
        row.ready_date.slice(0, 10),
        row.ready_time,
        row.siding_date.slice(0, 10),
        row.siding_time,
      );

      rlDpValue = secondsToHHMM(Math.floor(diff.totalMilliseconds));
    }

    const isTextArea = field === "remarks" || field === "exp_ready_remark";

    return (
      <td style={{ margin: 0, padding: 0 }}>
        {isSelect ? (
          <select
            style={defaultStyle}
            className="form-select"
            disabled={row.disabled}
            value={row[field] || ""}
            onChange={(e) => handleChange(index, field, e.target.value)}
          >
            <option value="">Select</option>
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : field === "rl_dp" ? (
          <input
            style={defaultStyle}
            type="text"
            className="form-control"
            disabled
            value={rlDpValue}
            readOnly
          />
        ) : isTextArea ? (
          <textarea
            className="form-control m-0 p-0"
            disabled={row.disabled || disabled}
            value={row[field] || ""}
            rows={2}
            style={{
              ...defaultStyle,
              minWidth: "180px",
              minHeight: "35px",
              resize: "vertical",
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              overflow: "hidden",
              height: "auto",
            }}
            onInput={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = `${e.target.scrollHeight}px`;
            }}
            onChange={(e) => handleChange(index, field, e.target.value)}
          />
        ) : (
          <input
            style={{
              ...defaultStyle,
              minWidth:
                field === "destination" || field === "commodity"
                  ? "160px"
                  : defaultStyle.minWidth,
            }}
            type={type}
            className="form-control"
            disabled={row.disabled || disabled}
            value={
              type === "date"
                ? row[field]?.slice(0, 10) || ""
                : row[field] || ""
            }
            title={row[field] || ""}
            onChange={(e) => {
              handleChange(
                index,
                field,
                e.target.value === "" ? null : e.target.value,
              );
            }}
          />
        )}
      </td>
    );
  };
  useEffect(() => {
    if (rows.filter((f) => f.fcn_no).length) {
      setIndentCount((prev) => {
        return { ...prev, cemt: rows.filter((f) => f.fcn_no).length };
      });
    }
  }, [rows.filter((f) => f.fcn_no).length]);

  const uploadData = async (oldData, newData) => {
    setShow(false);
    setResult(null);
    setLoading(true);
    try {
      const payloads = separateInsertAndUpdate(
        oldData,
        newData,
        EXCLUDED_NEW_KEYS,
      );

      const keysToRemove = [
        "destination",
        "commodity",
        "wagons",
        "wagon_type",
        "fcn_no",
        "fcn_date",
        "fcn_time",
        "disabled",
        "isNew",
        "siding",
        "sn",
        "exp_ready_date",
        "exp_ready_time",
        "exp_ready_found",
        "exp_ready_remark",
        "checkedDeleted",
      ];

      const removeKeys = (arr) =>
        arr.map((obj) => {
          const newObj = { ...obj };
          keysToRemove.forEach((key) => delete newObj[key]);
          return newObj;
        });

      const insertPayload = removeKeys(
        payloads.insert.map((p) => {
          return { ...p, created_by: userData.id };
        }),
      );
      //

      const updatePayload = removeKeys(
        payloads.update.map((p) => ({
          ...p,
          updates: {
            ...p.updates,
            updated_by: userData.id,
          },
        })),
      );
      const keysToRemoveFromUpdate = [
        "exp_ready_date",
        "exp_ready_time",
        "exp_ready_remark",
      ];

      const filteredUpdatePayload = updatePayload.filter((item) => {
        const updates = item.updates || {};

        return !keysToRemove.some((key) => key in updates);
      });

      // Create dispatch payload only when placed_date/time changed
      const expReadyInsertPayload = [];
      const expReadyUpdatePayload = [];
      newData.forEach((row) => {
        // Ignore completely empty Exp Ready rows
        if (
          !row.exp_ready_date &&
          !row.exp_ready_time &&
          !row.exp_ready_remark
        ) {
          return;
        }

        // Existing record -> UPDATE
        if (row.exp_ready_found) {
          expReadyUpdatePayload.push({
            id: row.exp_ready_found,
            updates: {
              exp_ready_date:
                row.exp_ready_date == "" ? null : row.exp_ready_date,
              exp_ready_time:
                row.exp_ready_time == "" ? null : row.exp_ready_time,
              exp_ready_remark: row.exp_ready_remark,
              updated_by: userData.id,
            },
          });
        }
        // New record -> INSERT
        else if (row.id) {
          expReadyInsertPayload.push({
            loading_id: row.id,
            exp_ready_date:
              row.exp_ready_date == "" ? null : row.exp_ready_date,
            exp_ready_time:
              row.exp_ready_time == "" ? null : row.exp_ready_time,
            exp_ready_remark: row.exp_ready_remark,
            created_by: userData.id,
            updated_by: userData.id,
          });
        }
      });
      const hasValidPlacedData = (obj) => {
        const data = obj.updates || obj;

        return (
          (data.placed_date != null && data.placed_date !== "") ||
          (data.placed_time != null && data.placed_time !== "")
        );
      };

      const dispatchPayload = [
        ...new Map([
          // From update payload
          ...filteredUpdatePayload
            .filter((o) =>
              ["placed_date", "placed_time"].some(
                (key) => key in (o.updates || {}),
              ),
            )
            .map((o) => {
              const action = hasValidPlacedData(o) ? "placed" : "accept";

              return [
                o.ind_id,
                {
                  id: o.ind_id,
                  updates: {
                    action,
                  },
                },
              ];
            }),

          // From insert payload
          ...insertPayload
            .filter((o) =>
              ["placed_date", "placed_time"].some((key) => key in o),
            )
            .map((o) => {
              const action = hasValidPlacedData(o) ? "placed" : "accept";

              return [
                o.indent_hdr_id,
                {
                  id: o.indent_hdr_id,
                  updates: {
                    action,
                  },
                },
              ];
            }),
        ]).values(),
      ];

      const messages = [];
      const errors = [];
      // INSERT

      if (insertPayload.length > 0) {
        // console.log("insert", insertPayload);
        try {
          const res = await axios.post(`${urlPrefix}insert/insertData`, {
            table_name: "t_loading_hdr",
            update_on_duplicate: true,
            exclude_update_columns: ["id", "indent_hdr_id"],
            data: insertPayload,
          });
          if (res?.data?.success) {
            messages.push(`Inserted ${insertPayload.length} record(s)`);
          } else {
            errors.push("Insert failed");
          }
        } catch (err) {
          // console.log(err);
          errors.push(`Insert: ${err.message}`);
        }
      }

      // UPDATE
      // console.log(filteredUpdatePayload, payloads);
      if (filteredUpdatePayload.length > 0) {
        // console.log("up");
        console.log(filteredUpdatePayload);
        try {
          const res = await axios.put(`${urlPrefix}updateAllMasterData`, {
            table_name: "t_loading_hdr",
            rows: filteredUpdatePayload,
          });
          if (res?.data?.success) {
            messages.push(`Updated ${filteredUpdatePayload.length} record(s)`);
          } else {
            errors.push("Update failed");
          }
        } catch (err) {
          errors.push(`Update: ${err.message}`);
        }
      }

      // console.log(dispatchPayload);
      // DISPATCH STATUS UPDATE
      if (dispatchPayload.length > 0) {
        // console.log("placed");

        try {
          const res = await axios.put(`${urlPrefix}updateAllMasterData`, {
            table_name: "t_indent_hdr",
            rows: dispatchPayload,
          });
          if (res?.data?.success) {
            messages.push(
              `Placed updated for ${dispatchPayload.length} indent(s)`,
            );
          } else {
            errors.push("placed update failed");
          }
        } catch (err) {
          errors.push(`placed: ${err.message}`);
        }
      }
      if (expReadyInsertPayload.length > 0) {
        try {
          const res = await axios.post(`${urlPrefix}insert/insertData`, {
            table_name: "t_exp_ready",
            update_on_duplicate: true,
            exclude_update_columns: ["id", "exp_ready_date"],
            data: expReadyInsertPayload,
          });

          if (res.data.success) {
            messages.push(
              `Inserted ${expReadyInsertPayload.length} Exp Ready record(s)`,
            );
          } else {
            errors.push("Exp Ready insert failed");
          }
        } catch (err) {
          errors.push(`Exp Ready Insert: ${err.message}`);
        }
      }
      if (expReadyUpdatePayload.length > 0) {
        try {
          const res = await axios.put(`${urlPrefix}updateAllMasterData`, {
            table_name: "t_exp_ready",
            rows: expReadyUpdatePayload,
          });
          if (res.data.success) {
            messages.push(
              `Updated ${expReadyUpdatePayload.length} Exp Ready record(s)`,
            );
          } else {
            errors.push("Exp Ready update failed");
          }
        } catch (err) {
          errors.push(`Exp Ready Update: ${err.message}`);
        }
      }

      setShow(true);
      setResult({
        success: errors.length === 0,
        message: [...messages, ...errors].join("\n"),
      });
    } catch (error) {
      console.error(error);

      setShow(true);
      setResult({
        success: false,
        message: `Unexpected error: ${error.message}`,
      });
    } finally {
      setLoading(false);
      setReFetch((p) => !p);
    }
  };

  const handleDeleteData = async (row, deleteIndent) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete loading Data and Indent data Too for fcn no ${row.fcn_no}? `,
    );
    let response;
    if (confirmed) {
      // Delete logic here

      try {
        response = await axios.delete(
          `${urlPrefix}delete/cls_indent?id=${row.indent_hdr_id}&flag=delete`,
        );
        setShow(true);
        setResult({
          success: response.data.success,
          message: response.data.message,
        });
      } catch (err) {
        setShow(true);
        setResult({
          success: false,
          message: err.response.data.message || "failed to delete",
        });
      } finally {
        setLoading(false);
        setReFetch((p) => !p);
      }
    }
  };
  return (
    <div>
      {loading && <Loading />}
      <div className="table-responsive">
        <div style={{ maxHeight: "600px", overflow: "auto" }}>
          <table className="table table-hover table-striped table-bordered m-0">
            <thead style={{ fontSize: "12px" }}>
              <tr
                className="table-dark text-uppercase"
                style={{ fontSize: "11px", letterSpacing: "0.5px" }}
              >
                {tableHead.map((h, i) => (
                  <th
                    className="m-0"
                    key={i}
                    rowSpan={h.rowSpan}
                    colSpan={h.colSpan}
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                      position: "sticky",
                      top: 0,
                      zIndex: 30,
                      margin: "0px",

                      background: "#212529",
                    }}
                  >
                    {h.head}
                  </th>
                ))}
              </tr>

              <tr className="table-dark  m-0 ">
                {subHead.map((text, i) => (
                  <th
                    className="m-0 "
                    key={i}
                    style={{
                      margin: "0px",
                      textAlign: "center",
                      position: "sticky",
                      top: "38px", // height of first header row
                      zIndex: 30,
                      background: "#212529",
                    }}
                  >
                    {text}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row, index) => (
                <tr
                  onClick={() => {
                    setSelectedRowIndex(index);
                  }}
                  key={index}
                  style={{
                    border: selectedRowIndex === index && "2px solid #4c93e6",
                  }}
                >
                  {/* First column */}
                  <td
                    style={{
                      cursor: "pointer",
                      position: "sticky",
                      left: 0,
                      zIndex: 20,
                      background: "white",
                      minWidth: "60px",
                    }}
                  >
                    {index + 1}
                  </td>

                  {/* Second column */}
                  <td
                    style={{
                      cursor: "pointer",
                      position: "sticky",
                      left: "60px", // width of first column
                      zIndex: 20,
                      background: "white",
                      minWidth: "120px",
                    }}
                  >
                    {row.siding}
                  </td>
                  {renderInput(row, index, "destination", "text", true)}
                  {renderInput(row, index, "embedded_supply")}
                  {renderInput(row, index, "last_ire")}
                  {renderInput(
                    row,
                    index,
                    "commodity",
                    "text",
                    true,
                    // true,
                    // options.commodity || [],
                  )}
                  {renderInput(row, index, "wagons", "number", true)}
                  {renderInput(row, index, "loading_wagons", "number")}
                  {renderInput(row, index, "wagon_type", "text", true)}
                  {renderInput(row, index, "fcn_no", "number", true)}
                  {renderInput(row, index, "fcn_date", "date", true)}
                  {renderInput(row, index, "fcn_time", "time", true)}
                  {renderInput(row, index, "arr_date", "date")}
                  {renderInput(row, index, "arr_time", "time")}
                  {renderInput(row, index, "placed_date", "date")}
                  {renderInput(row, index, "placed_time", "time")}
                  {renderInput(row, index, "exp_ready_date", "date")}
                  {renderInput(row, index, "exp_ready_time", "time")}
                  {renderInput(row, index, "exp_ready_remark", "textarea")}
                  {renderInput(row, index, "ready_date", "date")}
                  {renderInput(row, index, "ready_time", "time")}
                  {renderInput(row, index, "bpc")}
                  {renderInput(row, index, "valid", "text", true, true, [
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ])}
                  {renderInput(row, index, "siding_date", "date")}
                  {renderInput(row, index, "siding_time", "time")}
                  {renderInput(row, index, "rl_dp", "time", true)}
                  {renderInput(row, index, "remarks")}
                  <td onClick={(e) => e.stopPropagation()}>
                    <button
                      type="button"
                      className="ms-1 btn btn-sm btn-outline-danger"
                      style={{ fontSize: "10px" }}
                      onClick={(e) => {
                        handleDeleteData(row);
                      }}
                    >
                      <MdDelete style={{ fontSize: "13px" }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div
        className="btn btn-sm btn-outline-success"
        onClick={() => {
          uploadData(
            tempRows.filter((f) => f.indent_hdr_id != null),
            rows.filter((f) => f.indent_hdr_id != null),
          );
        }}
      >
        save
      </div>
      <div className="p-3">
        {result?.success === true ? (
          <SuccessMsg
            head="Success"
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={`${result?.message || ""}, ${result?.error || ""}`}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default CementLoading;
